import { Component, Injector, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { SecondPageEditBase } from 'vnpost-shared';
import { CategoryService } from '../../services/category.service';
import { ListTitleService } from '../../services/list-title.service';

@Component({
  selector: 'app-edit-list-title',
  templateUrl: './edit-list-title.component.html',
  styleUrls: ['./edit-list-title.component.css'],
})
export class EditListTitleComponent
  extends SecondPageEditBase
  implements OnInit
{
  listStatus: { label: string; value: number }[] = [
    { label: 'Đang áp dụng', value: 1 },
    { label: 'Ngừng áp dụng', value: 0 },
  ];
  isDisable: any;

  constructor(
    protected _listTileService: ListTitleService,
    protected _injector: Injector
  ) {
    super(_listTileService, _injector);
    this.formGroup = new UntypedFormGroup({
      jobTitleLevelName: new UntypedFormControl('', [Validators.required]),
      jobTitleName: new UntypedFormControl('', [Validators.required]),
      commissionRate: new UntypedFormControl('', [Validators.required]),
      status: new UntypedFormControl('', [Validators.required]),
      notes: new UntypedFormControl(''),
    });
  }

  ngOnInit() {}

  onShowPopup(model: any) {
    this.isDisable = model.isDisable;
    this.validationSummary.resetErrorMessages();
    this.resetForm();

    if (model.id > 0) {
      this._listTileService.getDetail(model.id).then(
        (rs) => {
          this.itemDetail = rs.data;
        },
        (error) => {
          this._notifierService.showWarning(
            this._translateService.instant('MESSAGE.NOT_FOUND_ERROR')
          );
        }
      );
    }
  }

  async save() {
    this.submitting = true;

    if (this.formGroup.invalid) {
      this.submitting = false;
      this.validationSummary.showValidationSummary();
      return;
    }

    this.onUpdate();
  }

  onUpdate() {
    this._listTileService.update(this.itemDetail.id, this.itemDetail).then(
      (response) => {
        this.closePopupMethod(true);
        this._notifierService.showUpdateDataSuccess();
        this.onAfterSave();
        this.submitting = false;
      },
      (error) => {
        this._notifierService.showUpdateDataFailed();
        this.submitting = false;
      }
    );
  }
}
